// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M4.5 6H5.5V8H1.5V6H2.5L2.5 4H1.5L1.5 2H2.5C3.60457 2 4.5 2.89543 4.5 4V6Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M7 20V18H22V20H7Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M7 13V11H22V13H7Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M7 6V4H22V6H7Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M1.5 9.25H3.96967C4.81485 9.25 5.5 9.93515 5.5 10.7803C5.5 11.1862 5.33877 11.5754 5.05178 11.8624L4.16421 12.75H5.5V14.75H1.5V13.4142C1.5 12.8838 1.71071 12.3751 2.08579 12L2.83579 11.25H1.5V9.25Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M1.5 15.75V17.75H3.5V18H2V20H3.5V20.25H1.5V22.25H3.5C4.60457 22.25 5.5 21.3546 5.5 20.25V17.75C5.5 16.6454 4.60457 15.75 3.5 15.75H1.5Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-list-numbered')
export default class ListNumberedIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'list-numbered',
    }
  }
}
